/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useState } from 'react'
import PersonalisedForYou from './PersonalisedForYou'
import { useDispatch, useSelector } from 'react-redux'
import { fetchKeyTakeaways, selectGeneratedKeypoints, selectKeypointsGeneratedForLesson } from '../../redux/keyTakeawaySlice'
import { BarLoader, SyncLoader } from 'react-spinners'
import { fetchCourseModule, selectCourseModule, selectLessonBySlugs } from '../../redux/courseModuleSlice'
import { toast } from 'react-toastify'
import { selectCurrentCourseId } from '../../redux/courseListSlice'
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../../utilities/constants'
import { fetchLessonQuiz } from '../../redux/lessonQuizSlice'
import jsPDF from 'jspdf'
import { getKeypointList } from '../../utilities/videoPlayerApi'

const KeyTakeAway = ({
    userGoal,
    setUserGoal,
    course_slug,
    lesson_slug,
    module_slug,
}) => {

    const [keytakeawayLoading, setKeyTakeawayLoading] = useState(false)
    const courseModule = useSelector(selectCourseModule)
    const existingUserGoal = courseModule?.user_goal
    const lessonDetails = useSelector((state) => selectLessonBySlugs(state, module_slug, lesson_slug))
    const videoId = lessonDetails?.video_id || lessonDetails?.video_url?.split("?")?.[1]?.split("=")?.[1]
    const lessonId = lessonDetails?.lesson_id
    const courseId = useSelector(selectCurrentCourseId)
    const generatedKeypoints = useSelector((state) => selectGeneratedKeypoints(state, courseId, module_slug, lessonId))
    const keypointsGeneratedForLesson = useSelector((state) => selectKeypointsGeneratedForLesson(state, courseId, module_slug, lessonId))
    const keypoints = lessonDetails?.keypoints || generatedKeypoints
    const keypointList = getKeypointList(keypoints)
    const dispatch = useDispatch()

    const refreshCourse = () => dispatch(fetchCourseModule({ course_id: courseId })).unwrap()

    const reconcileAfterFailure = async (error) => {
        console.error(error)
        try {
            await refreshCourse()
        } catch (refreshError) {
            console.error(refreshError)
        }
    }

    useEffect(() => {
        if (existingUserGoal?.length > 0 && !keypoints?.length && !keypointsGeneratedForLesson) {
            setKeyTakeawayLoading(true)
            const fetchData = async () => {
                try {
                    await dispatch(fetchKeyTakeaways({
                        course_id: courseId,
                        module_slug,
                        video_id: videoId,
                        goal: existingUserGoal,
                        lesson_id: lessonId,
                    })).unwrap()
                    await refreshCourse()
                } catch (error) {
                    await reconcileAfterFailure(error)
                } finally {
                    setKeyTakeawayLoading(false)
                }
            }
            fetchData()
        }
    }, [lesson_slug, keypointList.length, keypointsGeneratedForLesson])

    const handleSubmit = (e) => {
        e.preventDefault()
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_USER_GOAL_FROM_KEYTAKEAWAY_WAS_CLICKED)
        if (userGoal.length <= 0) {
            return toast.error("Enter your goal")
        }
        const fetchData = async () => {
            setKeyTakeawayLoading(true)
            try {
                await dispatch(fetchKeyTakeaways({
                    course_id: courseId,
                    module_slug,
                    video_id: videoId,
                    goal: userGoal,
                    lesson_id: lessonId,
                })).unwrap()
                await dispatch(fetchLessonQuiz({
                    course_id: courseId,
                    module_slug,
                    video_id: videoId,
                    lesson_id: lessonId,
                    goal: userGoal,
                })).unwrap()
                await refreshCourse()
            } catch (error) {
                await reconcileAfterFailure(error)
            } finally {
                setKeyTakeawayLoading(false)
            }
        };
        fetchData();
        setUserGoal('')
    }

    const generatePDF = () => {
        const pdf = new jsPDF()
        pdf.setFontSize(16)
        pdf.text("Keypoints", 10, 10)
        pdf.setFontSize(12)
        let yPos = 20
        keypointList.forEach((keypoint, index) => {
            const maxWidth = 180
            const lines = pdf.splitTextToSize(keypoint, maxWidth)
            lines.forEach((line, lineIndex) => {
                pdf.text(line, 10, yPos + (lineIndex * 5))
            })
            yPos += (lines.length * 5) + 5
        })
        pdf.save('keytakeways.pdf')
    }

    return (

        <>
            {!existingUserGoal?.length > 0 ? (
                !keytakeawayLoading ? <div className='p-4'>
                    <h2 className='text-xl font-semibold lg:hidden'>Key Takeaways</h2>
                    <p className='italic text-sm opacity-50 leading-[17px] my-2.5'>Provide us your goal and we’ll personalise key takeaways for you.</p>
                    <p className='text-sm font-medium mt-10 mb-1.5'>With this course, I want to _______</p>
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            placeholder='Get a job as a data scientist, get a raise of...'
                            value={userGoal}
                            onChange={(e) => setUserGoal(e.target.value)}
                            className='w-full bg-[#17395A] rounded-xl goal border-none placeholder:text-sm'
                        />
                        <div className='flex justify-end mt-4'>
                            <button type='submit' disabled={!userGoal.length > 0} className='py-2 disabled:opacity-50 px-5 rounded-xl bg-[#7FC241] text-[#071D2D] cursor-pointer'>Submit</button>
                        </div>
                    </form>
                </div> : <div className='h-[276px] w-full flex flex-col items-center justify-center'>
                    <p className='mb-2'>Loading</p>
                    <BarLoader color='#7FC241' />
                </div>
            ) : lessonDetails?.lesson_status === "completed" || lessonDetails?.lesson_status === "ongoing" || lessonDetails?.lesson_status === "inprogress" || lessonDetails?.lesson_status === "quizpending" ? (
                !keytakeawayLoading ? <div className='p-3 lg:p-6'>
                    <div className='flex justify-between items-center lg:hidden'>
                        <h2 className='text-xl font-semibold'>Key Takeaways</h2>
                        <PersonalisedForYou />
                    </div>
                    <div id='keytakeways' className='leading-[17px] h-[228px] mt-4 lg:mt-0 pr-1 pt-1 overflow-y-scroll text-sm takeaway' style={{ scrollBehavior: 'smooth' }}>
                        {keypointList.map((item, index) => (
                            <p className='mb-3' key={index}>{item}</p>
                        ))}
                    </div>
                    <div className='flex gap-2 items-center border w-fit px-3 py-1.5 rounded-lg mt-3 cursor-pointer' onClick={generatePDF}>
                        <p className='text-sm'>Download</p>
                        <img src="https://img.learntube.ai/public-assets/Lead%20Generation/Vector%20(11).png?updatedAt=1713357285665" width={14} height={14} alt="" />
                    </div>
                </div> : <div className='h-[228px] w-full flex flex-col items-center justify-center'>
                    <p className='mb-2'>Loading</p>
                    <SyncLoader color='#7FC241' />
                </div>) :
                <div className='p-6 lg:h-[228px] relative'>
                    <h2 className='text-xl font-semibold lg:hidden'>Key Takeaways</h2>
                    <div className='mt-3 blur'>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Esse fuga suscipit, in, architecto veniam excepturi repellendus.</p>
                        <p className='mt-3'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet hic veniam, fuga delectus nostrum nemo possimus.</p>
                        <p className='mt-3'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet hic veniam, fuga delectus nostrum nemo possimus.</p>
                    </div>
                    <div className='absolute text-center flex flex-col items-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
                        <img src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Lock_6.svg?updatedAt=1689232670218" width={21} height={27} alt="" />
                        <p className='font-medium'>Watch Video To Unlock</p>
                    </div>
                </div>}
        </>
    )
}

export default KeyTakeAway
